module.exports = __webpack_public_path__ + "img/add-photo-third-icon.4dbb2837.svg";